export const LIFECYCLESTAGE = 'lifecyclestage';